import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Search, FileCheck2, Truck, Stethoscope } from "lucide-react";

const STEPS = [
    {
        Icon: Search,
        title: "Sélection du produit",
        desc: "Explorez le catalogue ou recevez les conseils d'un expert pour cibler l'équipement adapté à votre pratique.",
    },
    {
        Icon: FileCheck2,
        title: "Validation de la commande",
        desc: "Devis personnalisé envoyé sur WhatsApp, validation rapide, facturation conforme à votre exercice.",
    },
    {
        Icon: Truck,
        title: "Expédition rapide",
        desc: "Préparation sous 24 h ouvrées. Suivi temps réel, transporteur partenaire spécialisé matériel médical.",
    },
    {
        Icon: Stethoscope,
        title: "Livraison au cabinet",
        desc: "Réception sur site, démonstration possible, mise en service assistée par notre équipe technique.",
    },
];

const OrderingProcess = () => {
    const wrap = useRef(null);
    const { scrollYProgress } = useScroll({
        target: wrap,
        offset: ["start 80%", "end 30%"],
    });
    const lineScale = useTransform(scrollYProgress, [0, 1], [0, 1]);

    return (
        <section id="processus" className="relative py-24 md:py-32 bg-[#F5F5F7]">
            <div className="max-w-[1320px] mx-auto px-6 md:px-10">
                <div className="text-center max-w-2xl mx-auto">
                    <div className="dp-eyebrow">Processus</div>
                    <h2 className="mt-3 font-display text-4xl md:text-5xl lg:text-[56px] font-light tracking-tight text-neutral-900 leading-[1.05]">
                        Quatre étapes,{" "}
                        <span className="italic text-neutral-500">zéro friction.</span>
                    </h2>
                </div>

                <div ref={wrap} className="relative mt-20">
                    {/* Connecting line (desktop) */}
                    <div className="hidden md:block absolute top-9 left-[12.5%] right-[12.5%] h-[2px] bg-neutral-200" />
                    <motion.div
                        style={{ scaleX: lineScale, transformOrigin: "left center" }}
                        className="hidden md:block absolute top-9 left-[12.5%] right-[12.5%] h-[2px] bg-gradient-to-r from-[#0a84ff] via-[#00e5ff] to-[#0a84ff]"
                    />

                    <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-6 relative">
                        {STEPS.map((s, i) => {
                            const Icon = s.Icon;
                            return (
                                <motion.div
                                    key={s.title}
                                    initial={{ opacity: 0, y: 24 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true, margin: "-60px" }}
                                    transition={{ duration: 0.5, delay: i * 0.1 }}
                                    className="relative text-center"
                                >
                                    <div className="mx-auto relative">
                                        <div className="mx-auto w-[72px] h-[72px] rounded-full bg-white border border-black/[0.06] shadow-[0_10px_40px_-20px_rgba(10,132,255,0.4)] flex items-center justify-center relative z-10">
                                            <Icon className="w-7 h-7 text-[#0a84ff]" strokeWidth={1.4} />
                                        </div>
                                        <div className="absolute inset-0 w-[72px] h-[72px] mx-auto rounded-full dp-pulse" style={{ boxShadow: "0 0 30px rgba(0,229,255,0.25)" }} />
                                    </div>
                                    <div className="mt-5 dp-eyebrow">Étape {String(i + 1).padStart(2, "0")}</div>
                                    <h3 className="mt-1.5 font-display text-[19px] tracking-tight font-medium text-neutral-900">
                                        {s.title}
                                    </h3>
                                    <p className="mt-2 text-[14px] leading-relaxed text-neutral-500 max-w-xs mx-auto">
                                        {s.desc}
                                    </p>
                                </motion.div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default OrderingProcess;
